// Central product data for Twiggle Oral Care e-commerce

export const UNITS_PER_BOX = 144;
export const PRICE_PER_BOX = 169.0;

export const BULK_OFFERS = {
  freeEngravingMinBoxes: 5,
  freeBoxMinBoxes: 7,
  freeBoxProductId: 'twiggle-white',
};

export const PRODUCTS = [
  {
    id: 'twiggle-white',
    slug: 'twiggle-white',
    name: 'Twiggle White',
    fullName: 'Twiggle White – Ultra Soft',
    category: 'adult',
    pricePerBox: PRICE_PER_BOX,
    image: '/images/project/White brush and box.jpeg',
    images: [
      '/images/project/White brush and box.jpeg',
      '/images/project/whatsapp-image-white-2.jpeg',
      '/images/project/White Bamboo.jpg',
      '/images/project/UGC White.png',
    ],
    bristleType: 'Ultra Soft',
    bristleColor: 'White',
    badge: '144 Units / Box',
    shortDescription:
      'Ultra-soft white bristle bamboo toothbrush, gentle on sensitive gums – ideal for post-procedure patient care.',
    description:
      'Our ultra-soft white bamboo toothbrushes combine exceptionally gentle cleaning with an eco-conscious bamboo handle, offering dental clinics a premium and sustainable oral care solution.',
    features: [
      'Ultra-soft white bristles designed for sensitive teeth and gums',
      'Gentle, non-abrasive bristle design suitable for everyday enamel-safe brushing',
      'BPA-free bristles for comfortable daily oral care',
      'Smooth bamboo handle made from renewable natural material',
      'Lightweight ergonomic design for a comfortable brushing experience',
    ],
    packaging: {
      unitsPerBox: UNITS_PER_BOX,
      packagingType: 'Individually boxed',
      bulkAvailable: true,
    },
    deliveryTimeline: '3–4 weeks once order is confirmed',
    inStock: true,
  },
  {
    id: 'twiggle-green',
    slug: 'twiggle-green',
    name: 'Twiggle Green',
    fullName: 'Twiggle Green – Medium Soft',
    category: 'adult',
    pricePerBox: PRICE_PER_BOX,
    image: '/images/project/dual tone medium brush and box.jpeg',
    images: [
      '/images/project/dual tone medium brush and box.jpeg',
      '/images/project/dual tone onlt brush.jpeg',
      '/images/project/Greenn.png',
    ],
    bristleType: 'Medium Soft',
    bristleColor: 'White & Green',
    badge: '144 Units / Box',
    shortDescription:
      'Eco-friendly bamboo toothbrush with medium soft white & green bristles, ideal for daily use in dental clinics.',
    description:
      'Our medium-soft green bamboo toothbrushes provide an effective yet comfortable cleaning experience with an eco-conscious bamboo handle, making them an ideal sustainable choice for modern dental clinics.',
    features: [
      'Medium-soft green bristles designed for effective daily plaque removal',
      'Gentle, enamel-safe bristle design for comfortable brushing',
      'BPA-free bristles for reliable everyday oral care',
      'Bamboo handle made from renewable natural material',
      'Ergonomic lightweight design for a comfortable grip and brushing experience',
    ],
    packaging: {
      unitsPerBox: UNITS_PER_BOX,
      packagingType: 'Individually boxed',
      bulkAvailable: true,
    },
    deliveryTimeline: '3–4 weeks once order is confirmed',
    inStock: true,
  },
  {
    id: 'twiggle-charcoal',
    slug: 'twiggle-charcoal',
    name: 'Twiggle Charcoal',
    fullName: 'Twiggle Charcoal – Ultrasoft',
    category: 'adult',
    pricePerBox: PRICE_PER_BOX,
    image: '/images/project/Charcoal brush and box.jpeg',
    images: [
      '/images/project/Charcoal brush and box.jpeg',
      '/images/project/Twiggle charcoal.jpg',
      '/images/project/charcoal-infographic.jpeg',
      '/images/project/woman-charcoal-brush.jpeg',
    ],
    bristleType: 'Ultrasoft',
    bristleColor: 'Charcoal Black',
    badge: '144 Units / Box',
    shortDescription:
      'Premium charcoal-infused ultrasoft bristle bamboo toothbrush designed for gentle whitening and deep cleaning.',
    description:
      'Our charcoal bamboo toothbrushes combine gentle ultra soft-bristle cleaning with an eco-conscious bamboo handle, offering dental clinics a modern and sustainable oral care solution.',
    features: [
      'Ultrasoft bristles designed for gentle daily cleaning',
      'Non-abrasive bristle design suitable for enamel-safe brushing',
      'BPA-free bristles for everyday oral care',
      'Bamboo handle made from renewable natural material',
    ],
    packaging: {
      unitsPerBox: UNITS_PER_BOX,
      packagingType: 'Individually boxed',
      bulkAvailable: true,
    },
    deliveryTimeline: '3–4 weeks once order is confirmed',
    inStock: true,
  },
  {
    id: 'twiggle-mini-pink',
    slug: 'twiggle-mini-pink',
    name: 'Twiggle Mini – Pink',
    fullName: 'Twiggle Mini – Kids Ultrasoft Pink Bristles',
    category: 'kids',
    pricePerBox: PRICE_PER_BOX,
    image: '/images/project/Pink brush and box.jpeg',
    images: [
      '/images/project/Pink brush and box.jpeg',
      '/images/project/pink brush and box 2 boxes.jpeg',
      '/images/project/pink brush.png',
    ],
    bristleType: 'Ultra Soft',
    bristleColor: 'Pink',
    badge: '144 Units / Box',
    shortDescription:
      "Kid-sized bamboo toothbrush with ultra-soft pink bristles – perfect for pediatric dental clinics and schools.",
    description:
      "Our kids' ultra-soft pink bamboo toothbrushes are specially designed for young smiles, combining gentle cleaning with a sustainable bamboo handle for a fun and eco-conscious brushing experience.",
    features: [
      "Ultra-soft pink bristles designed for children's sensitive teeth and gums",
      'Gentle, enamel-safe bristle design for comfortable daily brushing',
      'BPA-free bristles for safe everyday oral care',
      "Small compact brush head ideal for children's mouths",
      'Smooth bamboo handle made from renewable natural material',
      'Lightweight ergonomic design for easy grip and better brushing control',
    ],
    packaging: {
      unitsPerBox: UNITS_PER_BOX,
      packagingType: 'Individually boxed',
      bulkAvailable: true,
    },
    deliveryTimeline: '3–4 weeks once order is confirmed',
    inStock: true,
  },
  {
    id: 'twiggle-mini-blue',
    slug: 'twiggle-mini-blue',
    name: 'Twiggle Mini – Blue',
    fullName: 'Twiggle Mini – Kids Ultrasoft Blue Bristles',
    category: 'kids',
    pricePerBox: PRICE_PER_BOX,
    image: '/images/project/Blue brush and box.jpeg',
    images: [
      '/images/project/Blue brush and box.jpeg',
      '/images/project/blue brush and box 2 brushes and boxes.jpeg',
      '/images/project/Kids bamboo toothbrush1.jpg',
      '/images/project/kid-blue-brush.jpeg',
    ],
    bristleType: 'Ultra Soft',
    bristleColor: 'Blue',
    badge: '144 Units / Box',
    shortDescription:
      'Kid-sized bamboo toothbrush with ultra-soft blue bristles – perfect for pediatric dental clinics and schools.',
    description:
      "Our kids' ultra-soft blue bamboo toothbrushes are specially designed for young smiles, combining gentle cleaning with a sustainable bamboo handle for a comfortable and eco-conscious brushing experience.",
    features: [
      "Ultra-soft blue bristles designed for children's sensitive teeth and gums",
      'Gentle, enamel-safe bristle design for comfortable daily brushing',
      'BPA-free bristles for safe everyday oral care',
      "Small compact brush head ideal for children's mouths",
      'Smooth bamboo handle made from renewable natural material',
      'Lightweight ergonomic design for easy grip and better brushing control',
    ],
    packaging: {
      unitsPerBox: UNITS_PER_BOX,
      packagingType: 'Individually boxed',
      bulkAvailable: true,
    },
    deliveryTimeline: '3–4 weeks once order is confirmed',
    inStock: true,
  },
];

export const QUANTITY_OPTIONS = [
  { value: 1, label: `1 box (${UNITS_PER_BOX} toothbrushes)` },
  { value: 2, label: `2 boxes (${UNITS_PER_BOX * 2} toothbrushes)` },
  { value: 5, label: `5 boxes (${UNITS_PER_BOX * 5} toothbrushes)` },
  { value: 7, label: `7 boxes (${UNITS_PER_BOX * 7} toothbrushes)` },
];

export const SUBSCRIPTION_OPTIONS = [
  { value: '1month', label: 'Every Month' },
  { value: '3months', label: 'Every 3 Months' },
  { value: '6months', label: 'Every 6 Months' },
];

export const getPaidBoxCount = (cartItems) =>
  cartItems
    .filter((item) => !item.isFreeGift)
    .reduce((sum, item) => sum + item.quantity, 0);

export const qualifiesForFreeEngraving = (cartItems) =>
  getPaidBoxCount(cartItems) >= BULK_OFFERS.freeEngravingMinBoxes;

export const qualifiesForFreeBox = (cartItems) =>
  getPaidBoxCount(cartItems) >= BULK_OFFERS.freeBoxMinBoxes;

export const getShippingInfo = (totalBoxes) => {
  if (totalBoxes >= 5) {
    return {
      label: 'Free Shipping',
      cost: 0,
      note: 'Free shipping on 5+ boxes across Canada',
    };
  }
  return {
    label: 'Standard Shipping',
    cost: 15,
    note: 'Standard shipping across Canada (Free on 5+ boxes)',
  };
};

export const getLinePrice = (item) => {
  if (item.isFreeGift) return 0;
  let optionsModifier = 0;
  if (item.selectedOptions) {
    optionsModifier = Object.values(item.selectedOptions).reduce((sum, opt) => sum + (opt.price_modifier || 0), 0);
  }
  const boxPrice = (item.product.pricePerBox || 169.00) + optionsModifier;
  const basePrice = boxPrice * item.quantity;
  if (item.subscription) {
    return basePrice * 0.9;
  }
  return basePrice;
};

export const getCartSubtotal = (cartItems) =>
  cartItems.reduce((sum, item) => sum + getLinePrice(item), 0);
